export default __webpack_public_path__ + "static/media/add-user.e8a237f8.svg";